document.addEventListener("DOMContentLoaded", () => {

const wrapper = document.querySelector(".testimonial-wrapper");
const track = document.querySelector(".testimonial-track");
const cards = document.querySelectorAll(".testimonial-card");
const prev = document.querySelector(".testimonial-prev");
const next = document.querySelector(".testimonial-next");

if (!wrapper || !track || cards.length === 0) return;

let index = 0;
let timer;

function cardsPerView() {
    return window.innerWidth <= 768 ? 1 : 2;
}

function updateSlider(){

    const gap = window.innerWidth <= 768 ? 0 : 30;

    const cardWidth = cards[0].getBoundingClientRect().width;

    track.style.transform =
        `translate3d(-${index * (cardWidth + gap)}px,0,0)`;

}
function nextSlide() {

    const perView = cardsPerView();

    index++;

    if (index > cards.length - perView) {
        index = 0;
    }

    updateSlider();
}

function prevSlide() {

    const perView = cardsPerView();

    index--;

    if (index < 0) {
        index = cards.length - perView;
    }

    updateSlider();
}

next.addEventListener("click", () => {
    nextSlide();
    restartAuto();
});

prev.addEventListener("click", () => {
    prevSlide();
    restartAuto();
});

function startAuto() {
    timer = setInterval(nextSlide, 5000);
}

function restartAuto() {
    clearInterval(timer);
    startAuto();
}

wrapper.addEventListener("mouseenter", () => clearInterval(timer));

wrapper.addEventListener("mouseleave", startAuto);

window.addEventListener("resize", updateSlider);

/* Touch Swipe */

let startX = 0;

wrapper.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
});

wrapper.addEventListener("touchend", e => {

    const endX = e.changedTouches[0].clientX;

    if (startX - endX > 50) nextSlide();

    if (endX - startX > 50) prevSlide();

    restartAuto();
});

updateSlider();

startAuto();

});